<template>
  <div class="legal">
    <LegalContent></LegalContent>
  </div>
</template>

<script>
import LegalContent from '../components/legal/legalContent'
export default {
  components: {
    LegalContent,
  },
}
</script>

<style lang="sass" scoped>
.legal
  width: 1200px
  margin: 0 auto
</style>



// WEBPACK FOOTER //
// src/page/Legal.vue